import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
// import { elsevierStyleSheetJSfileImport } from "../library/utils";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";
import showicon from '../library/svg/show-icon.svg';
import hideicon from '../library/svg/hide-icon.svg';
import warning from "../library/svg/warning.svg";
import { useParams, useNavigate } from "react-router-dom";

const ActivateAccount = () => {
    const { tokenId } = useParams();
    const [resetForm, setResetForm] = useState({
        email: "",
        newPassword1: "",
        newPassword2: "",
        passwordErrorMessage: "",
        passwordNotValid: null,
        isRevealed: false,
        isRevealed2: false,
    });
    const [passwordStrength, setPasswordStrength] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [validToken, setValidToken] = useState(true);
    const navigate = useNavigate();


    const handleSubmit = (event) => {
        event.preventDefault();
        const token = tokenId;
        const data = JSON.stringify({
            email: resetForm.email,
            password: resetForm.newPassword1
        })
        const configNewUser = {
            method: 'post',
            url: `${backendBookartUrl}/setpassword`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios(configNewUser)
            .then(response => {
                if (response.data.msg === 'Token has expired') {
                    setValidToken(false)
                }
                else {
                    navigate("/", { state: { message: response.data.message } });
                }
            })
            .catch(error => {
                console.log(error);
                setResetForm(prev => ({
                    ...prev,
                    newPassword1: "",
                    newPassword2: "",
                    passwordErrorMessage: ""
                }));
                setErrorMessage(error.response.data.errormessage);
            });
    };

    const setReveal = () => {
        setResetForm(prev => ({
            ...prev,
            isRevealed: !prev.isRevealed
        }));
    };

    const setReveal2 = () => {
        setResetForm(prev => ({
            ...prev,
            isRevealed2: !prev.isRevealed2
        }));
    };


    const handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;

        setResetForm(prev => ({ ...prev, [name]: value }));

        const { newPassword1, newPassword2 } = {
            ...resetForm,
            [name]: value
        };

        let passwordStrength = "";
        let passwordNotValidMessage = "";
        let passwordErrorMessage = "";

        if (newPassword1) {
            if (newPassword1.match("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})")) {
                passwordStrength = "strong";
            } else if (newPassword1.match("(?=.{8,})")) {
                passwordStrength = "fair";
                passwordNotValidMessage = "Please check the unique password criteria given below.";
            } else {
                passwordStrength = "weak";
                passwordNotValidMessage = "Please check the unique password criteria given below.";
            }
        }

        if (newPassword2 && newPassword1 !== newPassword2) {
            passwordErrorMessage = "Password doesn’t match. Enter the correct password.";
        }

        setPasswordStrength(passwordStrength);
        setResetForm(prev => ({
            ...prev,
            passwordErrorMessage,
            passwordNotValid: passwordNotValidMessage
        }));
    };

    return (
        <React.Fragment>
            <Header />
            <section className="body">
                <div className="container">
                    <div className="card-content">
                        <div className="es-card">
                            {validToken ? (
                                <div className="es-card-body">
                                    <img
                                        alt="Elsevier"
                                        className="elsevier-logo"
                                        src="/ElsevierStyleSheet/images/elsevier-wordmark.svg"
                                    />
                                    <h3 className="es-card-title">Welcome To Bookart</h3>
                                    <p className="es-card-text">
                                        Create a new password to continue with Bookart
                                    </p>
                                    <form className="resetForm" onSubmit={handleSubmit}>
                                        <div className="formGroup">
                                            <div className="es-input-text">
                                                <input
                                                    id="email"
                                                    name="email"
                                                    value={resetForm.email}
                                                    placeholder="&nbsp;"
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="email">Email</label>
                                            </div>
                                        </div>

                                        {/* New password */}
                                        <div className="formGroup">
                                            {resetForm.passwordNotValid === "" ? (
                                                <div className="es-input-text">
                                                    <input
                                                        id="newPassword1"
                                                        type={resetForm.isRevealed ? "text" : "password"}
                                                        name="newPassword1"
                                                        value={resetForm.newPassword1}
                                                        placeholder="&nbsp;"
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="newPassword1">New password</label>
                                                    {resetForm.newPassword1 && (
                                                        <img
                                                            className="password-manage"
                                                            title={resetForm.isRevealed ? "hide password" : "show password"}
                                                            src={resetForm.isRevealed ? hideicon : showicon}
                                                            onClick={setReveal}
                                                            alt="Toggle Password Visibility"
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="es-input-text">
                                                        <input
                                                            id="newPassword1"
                                                            type={resetForm.isRevealed ? "text" : "password"}
                                                            name="newPassword1"
                                                            value={resetForm.newPassword1}
                                                            placeholder="&nbsp;"
                                                            onChange={handleChange}
                                                        />
                                                        <label htmlFor="newPassword1">New password</label>
                                                        {resetForm.newPassword1 && (
                                                            <img
                                                                className="password-manage"
                                                                title={resetForm.isRevealed ? "hide password" : "show password"}
                                                                src={resetForm.isRevealed ? hideicon : showicon}
                                                                onClick={setReveal}
                                                                alt="Toggle Password Visibility"
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="text-start text-danger">
                                                        <img src={warning} className="warning-img" alt="Warning" />
                                                        {resetForm.passwordNotValid}
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* Re-enter password */}
                                        <div className="formGroup">
                                            {resetForm.passwordErrorMessage === "" ? (
                                                <div className="es-input-text">
                                                    <input
                                                        id="newPassword2"
                                                        type={resetForm.isRevealed2 ? "text" : "password"}
                                                        name="newPassword2"
                                                        value={resetForm.newPassword2}
                                                        placeholder="&nbsp;"
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="newPassword2">Re-enter new password</label>
                                                    {resetForm.newPassword2 && (
                                                        <img
                                                            className="password-manage"
                                                            title={resetForm.isRevealed2 ? "hide password" : "show password"}
                                                            src={resetForm.isRevealed2 ? hideicon : showicon}
                                                            onClick={setReveal2}
                                                            alt="Toggle Password Visibility"
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="es-input-text">
                                                        <input
                                                            id="newPassword2"
                                                            type={resetForm.isRevealed2 ? "text" : "password"}
                                                            name="newPassword2"
                                                            value={resetForm.newPassword2}
                                                            placeholder="&nbsp;"
                                                            onChange={handleChange}
                                                        />
                                                        <label htmlFor="newPassword2">Re-enter new password</label>
                                                        {resetForm.newPassword2 && (
                                                            <img
                                                                className="password-manage"
                                                                title={resetForm.isRevealed2 ? "hide password" : "show password"}
                                                                src={resetForm.isRevealed2 ? hideicon : showicon}
                                                                onClick={setReveal2}
                                                                alt="Toggle Password Visibility"
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="text-start text-danger">
                                                        <img src={warning} className="warning-img" alt="Warning" />
                                                        {resetForm.passwordErrorMessage}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <div className="formGroup text-start">
                                            <p className="passwordSpacing">
                                                Choose a unique password with a minimum of 8 characters.
                                                Include at least 1 number, a mix of lowercase and uppercase letters, and 1 symbol to make your password strong.
                                            </p>
                                        </div>
                                        <div id="passwordChecker" className="formGroup passwordMeterBar">
                                            {passwordStrength === "weak" ? (
                                                <div>
                                                    <div className="passwordMeter" id="passwordMeterWeak" style={{ background: "rgb(169, 43, 29)" }}>
                                                        Weak
                                                    </div>
                                                    &nbsp;
                                                    <div className="passwordMeter passwordFairText" id="passwordMeterFair"></div>
                                                    &nbsp;
                                                    <div className="passwordMeter" id="passwordMeterStrong"></div>
                                                    &nbsp;
                                                </div>
                                            ) : passwordStrength === "fair" ? (
                                                <div>
                                                    <div className="passwordMeter" id="passwordMeterWeak" style={{ background: "#FF6C00" }}></div>
                                                    &nbsp;
                                                    <div className="passwordMeter passwordFairText" id="passwordMeterFair" style={{ background: "#FF6C00" }}>
                                                        Fair
                                                    </div>
                                                    &nbsp;
                                                    <div className="passwordMeter" id="passwordMeterStrong"></div>
                                                </div>
                                            ) : passwordStrength === "strong" ? (
                                                <div>
                                                    <div className="passwordMeter" id="passwordMeterWeak" style={{ background: "rgb(73, 110, 1)" }}></div>
                                                    &nbsp;
                                                    <div className="passwordMeter passwordFairText" id="passwordMeterFair" style={{ background: "rgb(73, 110, 1)" }}></div>
                                                    &nbsp;
                                                    <div className="passwordMeter" id="passwordMeterStrong" style={{ background: "rgb(73, 110, 1)" }}>
                                                        STRONG
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="passwordMeter" id="passwordMeterWeak"></div>
                                                    &nbsp;
                                                    <div className="passwordMeter passwordFairText" id="passwordMeterFair"></div>
                                                    &nbsp;
                                                    <div className="passwordMeter" id="passwordMeterStrong"></div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="formGroup">
                                            <button
                                                className="es-button primary w-100"
                                                type="submit"
                                                disabled={
                                                    !(resetForm.newPassword2 === resetForm.newPassword1) ||
                                                    !passwordStrength.match("strong")
                                                }
                                            >
                                                <span>Continue</span>
                                            </button>
                                        </div>
                                        {errorMessage && (
                                            <div className="formGroup">
                                                <div className="error-message">{errorMessage}</div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            ) : (
                                <div className="es-card-body">
                                    <img
                                        alt="Elsevier"
                                        className="elsevier-logo"
                                        src="/ElsevierStyleSheet/images/elsevier-wordmark.svg"
                                    />
                                    <h3 className="es-card-title">Link Expired</h3>
                                    <p className="font-16">
                                        The link you are using is not valid/expired <br />
                                        Please contact your regional Account Manager or{" "}
                                        <a
                                            href="mailto:IndiaHSBooks@elsevier.com"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-auth="NotApplicable"
                                            data-linkindex="5"
                                        >
                                            {" Health Science Team"}
                                        </a>
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    );
};

export default ActivateAccount;